export default __webpack_public_path__ + "static/media/Proxima-Nova-Light.a5d2f114.ttf";